import React from 'react';
import { teamMembers } from '../../../data/team';

const Team: React.FC = () => {
  return (
    <section className="py-16">
      <div className="container-wide">
        <div className="section-title">
          <h2>Naša ekipa</h2>
          <div className="divider"></div>
          <p>
            Spoznajte ljudi, ki z ljubeznijo in predanostjo ustvarjajo najboljše bučno olje
            in ohranjajo tradicijo Oljarne Krajnc.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
          {teamMembers.map(member => (
            <TeamMemberCard key={member.id} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
};

// Team member card component
const TeamMemberCard: React.FC<{
  member: {
    id: string;
    name: string;
    position: string;
    bio: string;
    image: string;
  }
}> = ({ member }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 card-glow text-center group">
      <div className="relative overflow-hidden">
        <img 
          src={member.image || '/images/placeholder-person.jpg'} 
          alt={member.name} 
          className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-primary-700 bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold text-primary-700 mb-1">{member.name}</h3>
        <p className="text-secondary font-medium mb-4">{member.position}</p>
        <p className="text-accent-700">{member.bio}</p>
      </div>
    </div>
  );
};

export default Team;